import { getGlobals } from "storyblok/api"
import { getIndividualVideoPost, getVideoLibraryPaths } from "storyblok/videoLibrary"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import ArticleSection from "components/Archive/ArticleSection"
import InlineVideo from "components/DynamicComponent/atoms/InlineVideo"
import richText from "utilities/richText"

export default function IndividualVideoPost({ story }) {
  return (
    <main data-pagefind-body data-pagefind-sort="weight[data-weight]" data-weight="2">
      <StoryblokVisualEditor>
        <PageHeader
          blok={{
            type: "standard",
            heading: story?.content?.title,
            breadcrumbs: [{ text: "Video Library", href: "/video-library" }, { text: story?.content?.title }],
          }}
        />
        <ArticleSection>
          <InlineVideo blok={{ video: story?.content?.video }} title={story?.content?.title} />
          {richText(story?.content?.content)}
        </ArticleSection>
      </StoryblokVisualEditor>
    </main>
  )
}

export async function getStaticProps({ params: { video }, preview = null }) {
  const globals = await getGlobals("exclude-global-sections")

  const page = await getIndividualVideoPost(`video-library/${video}`, preview)

  return {
    props: {
      meta: page?.content?.twentysixty_seo ?? null,
      story: page ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getVideoLibraryPaths(),
    fallback: false,
  }
}
